import React from "react";
import Empty from "../../assets/assets/empty.svg";
import TestCard from "../../pages/Dashboard/TestCard";
import Product from "../../pages/Dashboard/Product";
import { PropTypes } from "prop-types";

const PosPending = (props) => {
  const {
    status,
    application,
    companyId,
    results,
    resultsLength,
    getStatus,
    categoryChoice,
    testCardStatus,
    userType,
    application_info,
    goToSinglePage,
    pos,
    expired
  } = props;

  const statusUpdate = status && status[0] && status[0].update;
  const updatingStatus =
    status && status[0] && status[0].nibss_super_admin_status;
  const updatingStatus2 = status && status[0] && status[0].status;
  const posId = pos && pos[0] && pos[0].id;
  const certifiedStatus =
    updatingStatus === "pending" || updatingStatus2 === "pending";

  return (
    !statusUpdate &&
    application.nibss_super_admin_status === "pending" &&
    (application.status === "pending" || application.status === "approved") && (
      <div className="pos-doc-sec">
        {application_info && application_info.length === 0 ? (
          <div className="empty2">
            <div>
              <img src={Empty} alt="empty2" />
            </div>
            <h1>No Products</h1>
            <p>
              There are no products recieved. Please check back when your <br />{" "}
              application has been accepted.
            </p>
            <br />
          </div>
        ) : (
            <div className="documentation">
              {application_info &&
                application_info.map((doc) => (
                  <div className="overlay-holder" key={doc.id}>
                    <Product
                      docUrl={doc.url}
                      id={doc.id}
                      docName={doc.name}
                      goToSinglePage={goToSinglePage}
                      iconUrl={doc.image_url}
                      colorCode={doc.color_code}
                    />
                  </div>
                ))}
            </div>
          )}
        <div className="testcard-main" style={{ marginTop: "0px" }}>
          <TestCard
            certifiedStatus={certifiedStatus}
            appId={posId}
            companyId={companyId}
            userType={userType}
            results={results}
            resultsLength={resultsLength}
            getUserStatus={getStatus}
            categoryChoice={categoryChoice}
            testCardStatus={testCardStatus}
                expired={expired}
          />
        </div>
      </div>
    )
  );
};

PosPending.propTypes = {
  status: PropTypes.array,
  application: PropTypes.object,
  companyId: PropTypes.number,
  results: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  resultsLength: PropTypes.array,
  getStatus: PropTypes.func,
  categoryChoice: PropTypes.number,
  testCardStatus: PropTypes.number,
  userType: PropTypes.string,
  application_info: PropTypes.array,
  goToSinglePage: PropTypes.func,
  pos: PropTypes.array,
};

export default PosPending;
